// import ModalForm from "./Form";
import RegistrantListForm from "./RegistrantListForm";
import { REGISTRATION_EVENT, DATATABLE_EXPORT } from "../../../../../Config/ApiUrl";
import * as actions from "../../../../../Config/ApiUrl";

export const Schema = {
	components: { RegistrantListForm },

	data() {
		return {
			DATATABLE_EXPORT,
			isAddEditModalActive: false,
			deleteConfirmationModalActive: false,
			migrationConfirmationModalActive: false,
			deleteLoader: false,
			migrationLoader: false,
			selectedUrl: this.ENDPOINT,
			Endpoint: REGISTRATION_EVENT,
			tableId: "registrant-list-table",
			formId: "registrant-list-form",
			rowData: {},
			tableColumns: [
				{
					title: "Child First Name",
					type: "text",
					key: "first_name",
				},
				{
					title: "Child Last Name",
					type: "text",
					key: "last_name",
				},
				{
					title: "D.O.B",
					type: "text",
					key: "date_of_birth",
				},
				{
					title: "Event Name",
					type: "custom-html",
					key: 'event_detail_id', 
                    modifier: (eventDetail) => {
                        return eventDetail?.event_id?.name ?? "-";
                    }
				},
				{
					title: "Location",
					type: "custom-html",
					key: "event_detail_id",
					modifier: (event_detail_id) => {
						return event_detail_id?.location;
					}
				},
				{
					title: "CLC ID Number",
					type: "text",
					key: "clc_id_number",
				},
			
			],
			actionObj: {
				title: this.$t("action"),
				type: "action",
			},
			options: {
				name: "RegistrantListTable",
				url: REGISTRATION_EVENT,
				showHeader: true,
				enableHighlights: true,
				// enableRowSelect: true,
				enableSaveFilter: true,
				columns: [],
				actions: [
					// {
					// 	title: this.$t("edit"),
					// 	icon: "edit",
					// 	type: "none",
					// 	component: "app-add-modal",
					// 	modalId: "registrant-list-form",
					// },
					{
						title: 'Migration to leads',
						icon: "external-link",
						type: "none",
						component: "app-migration-modal",
						modalId: "demo-migration",
						modifier: (row) => {
							return row.is_clc_student != "1" 
								? true
								: false;
						},
					},
					{
						title: this.$t("delete"),
						icon: "trash",
						type: "none",
						component: "app-confirmation-modal",
						modalId: "demo-delete",
						modifier: (row) => {
							return row.is_clc_student != "1" 
								? true
								: false;
						},
					},
				],
				filters: [
				],
				showFilter: true,
				showSearch: true,
				showCount: true,
				showClearFilter: true,
				paginationType: "pagination",
				responsive: true,
				rowLimit: 10,
				showAction: true,
				orderBy: "desc",
				actionType: "default",
			},
		};
	},
	methods: {
	},
};
